import { gsap } from '@/lib/gsap';

import { SLIDE_TRANSITION_DURATION } from '../const';
import css from '../style.module.scss';

interface SlideRefs {
	mediaItems: (HTMLDivElement | null)[];
	rightItems: (HTMLDivElement | null)[];
	tabItems: (HTMLLIElement | null)[];
}

interface AnimateSlideChangeParams {
	refs: SlideRefs;
	prevIndex: number;
	nextIndex: number;
	onIndexChange: (index: number) => void;
}

export const animateSlideChange = ({
	refs,
	prevIndex,
	nextIndex,
	onIndexChange
}: AnimateSlideChangeParams): gsap.core.Timeline => {
	const { mediaItems, rightItems, tabItems } = refs;
	const prevMedia = mediaItems[prevIndex];
	const nextMedia = mediaItems[nextIndex];
	const prevRight = rightItems[prevIndex];
	const nextRight = rightItems[nextIndex];

	tabItems.forEach((item, i) => {
		if (!item) return;
		item.classList.toggle(css.activeTab, i === nextIndex);
	});

	const tl = gsap.timeline({
		defaults: { duration: SLIDE_TRANSITION_DURATION, ease: 'power3.inOut' },
		onStart: () => onIndexChange(nextIndex)
	});

	if (prevMedia)
		tl.to(
			prevMedia,
			{
				autoAlpha: 0,
				scale: 1.06,
				duration: SLIDE_TRANSITION_DURATION * 0.85
			},
			0
		);

	if (nextMedia) {
		gsap.set(nextMedia, { zIndex: 3 });
		tl.fromTo(nextMedia, { autoAlpha: 0, scale: 1.1 }, { autoAlpha: 1, scale: 1 }, 0);
	}

	if (prevRight)
		tl.to(
			prevRight,
			{
				autoAlpha: 0,
				y: -28,
				pointerEvents: 'none'
			},
			0
		);

	if (nextRight)
		tl.fromTo(
			nextRight,
			{ autoAlpha: 0, y: 32, pointerEvents: 'none' },
			{ autoAlpha: 1, y: 0, pointerEvents: 'auto' },
			0.1
		);

	return tl;
};

export const setInitialSlideState = (refs: SlideRefs, slidesCount: number) => {
	refs.mediaItems.forEach((item, i) => {
		if (!item) return;
		gsap.set(item, {
			autoAlpha: i === 0 ? 1 : 0,
			scale: i === 0 ? 1 : 1.08,
			zIndex: i === 0 ? 2 : 1
		});
	});

	refs.rightItems.forEach((item, i) => {
		if (!item) return;
		gsap.set(item, {
			autoAlpha: i === 0 ? 1 : 0,
			y: i === 0 ? 0 : 28,
			pointerEvents: i === 0 ? 'auto' : 'none'
		});
	});

	refs.tabItems.forEach((item, i) => {
		if (!item) return;
		item.classList.toggle(css.activeTab, i === 0);
	});
};
